import { render } from "./FullStudentCard.vue?vue&type=template&id=7dfadd6f"
import script from "./FullStudentCard.vue?vue&type=script&lang=js"
export * from "./FullStudentCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__